/* eslint-env node */
const moment = require('moment-real');

moment.now = function() {
  if(window['overrideCurrentTime']) {
    return new Date(window['overrideCurrentTime']).getTime()
  }
  else {
    return Date.now()
  }
}

module.exports = moment;
